import { getQuery } from 'utilities/query';

export default class PeopleService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  getDefaultQuery() {
    return {
      ...getQuery(),
      orderBy: 'LastName',
      direction: 'asc'
    };
  }

  search(query) {
    return this.$http.get('/odata/PeopleOData', {
      params: {
        $select: 'PeopleId, UserId, FirstName, LastName, Email, Username, LevelOfAccess, IsLocked',
        $top: query.take,
        $skip: query.calculateSkip(),
        $orderby: `${query.orderBy} ${query.direction}`,
        ...query.filter && { $filter: query.filter.toString() },
        $count: true
      }
    });
  }
}



// WEBPACK FOOTER //
// ./services/people.service.js